export default __webpack_public_path__ + "static/media/09_TrustFall.33e2477b.jpg";